import React from "react";
import logo from "../logo.svg";
import Styles from "../styles/Loader.module.css";

/**
 * Branded loading indicator used on page/section transitions.
 * Shows the RigRestR logo with a rotating ring, glow and animated dots.
 */
const Loader = ({ text = "Loading" }) => {
  return (
    <div className={Styles.loader_container} role="status" aria-live="polite">
      <div className={Styles.badge}>
        <span className={Styles.ring} aria-hidden="true" />
        <img src={logo} alt="" className={Styles.logo} />
      </div>
      <span className={Styles.loader_text}>
        {text}
        <span className={Styles.dots} aria-hidden="true">
          <span />
          <span />
          <span />
        </span>
      </span>
    </div>
  );
};

export default Loader;
